import React, { Fragment, useEffect, useState } from 'react'
import { Card, Button, CardBody, CardHeader, CardTitle, Col, TabPane, Input, Row, FormFeedback, Badge, UncontrolledTooltip, Label, Modal, ModalBody, ModalFooter, ModalHeader, Form } from 'reactstrap'
import { Link, useHistory } from "react-router-dom"
import '@styles/react/apps/app-users.scss'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import '@styles/react/libs/react-select/_react-select.scss'
import '@styles/react/libs/tables/react-dataTable-component.scss'
import DataTable from 'react-data-table-component'
import { ExternalLink } from 'react-feather'
import { GetDataForLostItems } from './store'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useDispatch } from 'react-redux'

const IncidentLog = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [AllData, setAllData] = useState([])
  const MySwal = withReactContent(Swal)
  const companyIDs = JSON.parse(localStorage.getItem('companyID'))

  const RenderToData = async () => {
   

    const Sdate = new Date(props.sd),
    Smnth = (`0${Sdate.getMonth() + 1}`).slice(-2),
    Sday = (`0${Sdate.getDate()}`).slice(-2)
    const SD = await [Sdate.getFullYear(), Smnth, Sday].join("-")

    const Edate = new Date(props.ed),
    Emnth = (`0${Edate.getMonth() + 1}`).slice(-2),
    Eday = (`0${Edate.getDate()}`).slice(-2)
    const ED = await [Edate.getFullYear(), Emnth, Eday].join("-")
     
    const response = await dispatch(
      GetDataForLostItems({
        id: 0,
        companyID: companyIDs,
        userID: 1,
        q: "",
        page: 0,
        perPage: 0,
        sortColumn: "",
        sortType: "",
        fromDate: SD,
        toDate: ED,
           clientID: '0',
        driverID: '0',
        passengerID: '0',
        vehicletypeID: '0',
        categoryID: '0',
        paymentMethodID: '0',
        statusID: ''
      })
    )
     
    if (response.payload !== null && response.payload !== undefined) {
         
        const filteredData = response.payload.filter((responsedata) => responsedata.status === true)
         
        if (filteredData.length > 0) {
           
          setAllData(filteredData)
      } else {
        setAllData()
      }
    } 
  }


  useEffect(() => {
    RenderToData()
  }, [props.sd, props.ed])


  const columns1 = [
    // {
    //   name: <span style={{fontSize: 16, marginLeft: '-1px', fontWeight: 'bold'}}>Incident#</span>,
    //   sortable: false,
    //   minWidth: '5%',
    //   rowHeight: '100%',
    //   // rowHeight: '500px',
    //   sortField: 'incident',
    //   selector: row => row.incidentID,
    //   cell: row => <span>
    //     <span>
    //     <b>{`#${row.incidentID}`}</b>
    //     </span>
    //   </span>
    // },
    {
      name: <span style={{fontSize: 16, marginLeft: '-1px', fontWeight: 'bold'}}>Date</span>,
      sortable: true,
      rowHeight: '100%',
      minWidth: '13%',
      sortField: 'Date',
      selector: row => row.entryDate,
      cell: row => <span>
        <span><b>{row.entryDate}</b></span>
      </span>
    },
    {
      name: <span style={{fontSize: 16, marginLeft: '-1px', fontWeight: 'bold'}}>Category</span>,
      sortable: true,
      rowHeight: '100%',
      minWidth: '8%',
      sortField: 'Category',
      selector: row => row.categoryDescription,
      cell: row => <span>
        <span><b>{row.categoryDescription}</b></span>
      </span>
    },
    {
      name: <span style={{fontSize: 16, marginLeft: '-2px', fontWeight: 'bold'}}>Booking</span>,
      sortable: true,
      rowHeight: '100%',
      minWidth: '17%',
      sortField: 'Booking',
      selector: row => row.bookingID,
      cell: row => <span>
        <span id={`booking${row.incidentID}`}><b># {row.bookingID}</b></span>
        <UncontrolledTooltip placement='top' target={`booking${row.incidentID}`}>
        <div className="tooltip-content" style={{marginLeft:'0px'}}>
        <p>{`Date: ${new Date(row.bookingDate).toLocaleDateString()} Time: ${new Date(row.bookingDate).toLocaleTimeString()}`}</p>

          <p >{`From: ${row.pickUp}`}</p>
          <p >{`To: ${row.dropOff}`}</p>
        </div>
        </UncontrolledTooltip>
      </span>
    },
    {
      name: <span style={{fontSize: 16, marginLeft: '-2px', fontWeight: 'bold'}}>Driver </span>,
      sortable: true,
      rowHeight: '100%',
      minWidth: '8%',
      sortField: 'Driver',
      selector: row => row.driverName,
      cell: row => <span>
        <span id={`driver${row.incidentID}`}><b>{row.driverName}</b></span>
        <UncontrolledTooltip placement='top' target={`driver${row.incidentID}`}>
          {`Phone: ${row.phoneNo}`} <br></br>
          {`Email: ${row.email}`}
        </UncontrolledTooltip>
      </span>
    },
    {
      name: <span style={{fontSize: 16, marginLeft: '-2px', fontWeight: 'bold'}}>Passenger </span>,
      sortable: true,
      rowHeight: '100%',
      minWidth: '10%',
      sortField: 'Passenger',
      selector: row => row.passengerName,
      cell: row => <span>
        <span id={`passenger${row.incidentID}`}><b>{row.passengerName}</b></span>
        <UncontrolledTooltip placement='top' target={`passenger${row.incidentID}`}>
        <div className="tooltip-content" style={{marginLeft:'0px'}}>
          <p >{`Phone: ${row.phoneNo}`}</p>
          <p >{`Email: ${row.email}`}</p>
        </div>
        </UncontrolledTooltip>
      </span>
    },
    {
      name: <span style={{fontSize: 16, marginLeft: '-1px', fontWeight: 'bold'}}>Status </span>,
      sortable: true,
      rowHeight: '100%',
      minWidth: '8%',
      sortField: 'Status',
      selector: row => row.status,
      cell: row => (
        <span>{row.status === true ? <span><Badge className='text-capitalize' id='check' style={{ marginLeft: '1px' }} color={'success'} pill>{`  Open   `}</Badge>
       </span> : <span><Badge className='text-capitalize' id={`uncheck${row.incidentID}`} color={'light-danger'} pill>{`Closed`}</Badge><UncontrolledTooltip placement='top' target={`uncheck${row.incidentID}`}>
                <div className="tooltip-content" style={{marginLeft:'0px'}}>
                  {`Closed By: ${row.name}`}<br></br>
                  {`On Date: ${row.entryDate}`}<br></br>
                  {`Action Taken: ${row.actionTaken}`}
                  </div>
                </UncontrolledTooltip></span>}</span>
      )
    },
    {
      name: <span style={{fontSize: 16, fontWeight: 'bold'}}>Actions </span>,
      minWidth: '8%',
      rowHeight: '100%',
      cell: () => (
        <div style={{ width: '100%' }}>
          <Row lg='12' md='12' className='mr-1'>
            <Col lg='12' md='12' >
              <Button.Ripple className='btn-icon rounded-circle' color='flat-warning' tag={Link}>
                <span id='Edit' className='align-middle' ><ExternalLink size={20} onClick={() => {
                    history.push('/incident')
                }} />
                </span>
                <UncontrolledTooltip placement='top' target='Edit'>
                View in Incident Log
                </UncontrolledTooltip>
              </Button.Ripple>
            </Col>
          </Row>
        </div>
      )

    }
  ]

  return (
    <Fragment>
      <Card>
     
        <CardBody style={{padding: '0px'}}>
          <div className='react-dataTable'>
            <DataTable
              responsive
              paginationServer
              selectableRowsHighlight
              // columns={isMobile === true ? columns : columns1}
              columns={columns1}
              className='react-dataTable'
              data={AllData}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  )
}

export default IncidentLog